import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import App from './App';
import SmsOptInPage from './components/SmsOptInPage';
import TermsPage from './components/TermsPage';
import PrivacyPage from './components/PrivacyPage';
import ContactPage from './components/ContactPage';
import BookmarksPage from './pages/BookmarksPage';
import AdminPage from './pages/AdminPage';
import WorkflowTestPage from './pages/WorkflowTestPage';
import { initGlobalLinkTracking } from './utils/usageLogger';
import './index.css';

// Initialize background link click tracker
initGlobalLinkTracking();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/workflow-test" element={<WorkflowTestPage />} />
            <Route path="/preview-3col" element={<WorkflowTestPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/sms-optin" element={<SmsOptInPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/bookmarks" element={<BookmarksPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
